import { render, staticRenderFns } from "./survey-card.vue?vue&type=template&id=c668d94a&"
import script from "./survey-card.vue?vue&type=script&lang=js&"
export * from "./survey-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports